import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-auction-wallet-details-page',
  templateUrl: './auction-wallet-details-page.component.html',
  styleUrl: './auction-wallet-details-page.component.scss',
})
export class AuctionWalletDetailsPageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private rewardsWalletService: RewardsWalletService) {}
  id: number;
  screenSize = ScreenType;

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
